import * as React from 'react'
import { styleguide } from 'styleguide'

export default props => (
  <svg
    width="100%"
    height="100%"
    className={props.className}
    viewBox="0 0 160 104"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <g
      id="bar-Desktop-Copy-3"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd">
      <g id="bar-Group-50" transform="translate(0.000000, -1.000000)">
        <g
          id="bar-Group-47"
          transform="translate(43.000000, 1.000000)"
          fill={styleguide.colors.illustrationMarl}>
          <g id="bar-Group-46">
            <circle id="bar-Oval-8" cx="3.5" cy="3.5" r="3.5" />
            <circle id="bar-Oval-8" cx="3.5" cy="13.5" r="3.5" />
            <circle id="bar-Oval-8" cx="3.5" cy="23.5" r="3.5" />
          </g>
          <g id="bar-Group-46" transform="translate(10.000000, 0.000000)">
            <circle id="bar-Oval-8" cx="3.5" cy="3.5" r="3.5" />
            <circle id="bar-Oval-8" cx="3.5" cy="13.5" r="3.5" />
            <circle id="bar-Oval-8" cx="3.5" cy="23.5" r="3.5" />
          </g>
          <g id="bar-Group-46" transform="translate(20.000000, 0.000000)">
            <circle id="bar-Oval-8" cx="3.5" cy="3.5" r="3.5" />
            <circle id="bar-Oval-8" cx="3.5" cy="13.5" r="3.5" />
            <circle id="bar-Oval-8" cx="3.5" cy="23.5" r="3.5" />
          </g>
          <g id="bar-Group-46" transform="translate(30.000000, 0.000000)">
            <circle id="bar-Oval-8" cx="3.5" cy="3.5" r="3.5" />
            <circle id="bar-Oval-8" cx="3.5" cy="13.5" r="3.5" />
            <circle id="bar-Oval-8" cx="3.5" cy="23.5" r="3.5" />
          </g>
          <g id="bar-Group-46" transform="translate(40.000000, 0.000000)">
            <circle id="bar-Oval-8" cx="3.5" cy="3.5" r="3.5" />
            <circle id="bar-Oval-8" cx="3.5" cy="13.5" r="3.5" />
            <circle id="bar-Oval-8" cx="3.5" cy="23.5" r="3.5" />
          </g>
          <g id="bar-Group-46" transform="translate(50.000000, 0.000000)">
            <circle id="bar-Oval-8" cx="3.5" cy="3.5" r="3.5" />
            <circle id="bar-Oval-8" cx="3.5" cy="13.5" r="3.5" />
            <circle id="bar-Oval-8" cx="3.5" cy="23.5" r="3.5" />
          </g>
          <g id="bar-Group-46" transform="translate(60.000000, 0.000000)">
            <circle id="bar-Oval-8" cx="3.5" cy="3.5" r="3.5" />
            <circle id="bar-Oval-8" cx="3.5" cy="13.5" r="3.5" />
            <circle id="bar-Oval-8" cx="3.5" cy="23.5" r="3.5" />
          </g>
          <g id="bar-Group-46" transform="translate(70.000000, 0.000000)">
            <circle id="bar-Oval-8" cx="3.5" cy="3.5" r="3.5" />
            <circle id="bar-Oval-8" cx="3.5" cy="13.5" r="3.5" />
            <circle id="bar-Oval-8" cx="3.5" cy="23.5" r="3.5" />
          </g>
          <g id="bar-Group-46" transform="translate(80.000000, 0.000000)">
            <circle id="bar-Oval-8" cx="3.5" cy="3.5" r="3.5" />
            <circle id="bar-Oval-8" cx="3.5" cy="13.5" r="3.5" />
            <circle id="bar-Oval-8" cx="3.5" cy="23.5" r="3.5" />
          </g>
          <g id="bar-Group-46" transform="translate(90.000000, 0.000000)">
            <circle id="bar-Oval-8" cx="3.5" cy="3.5" r="3.5" />
            <circle id="bar-Oval-8" cx="3.5" cy="13.5" r="3.5" />
            <circle id="bar-Oval-8" cx="3.5" cy="23.5" r="3.5" />
          </g>
          <g id="bar-Group-46" transform="translate(100.000000, 0.000000)">
            <circle id="bar-Oval-8" cx="3.5" cy="3.5" r="3.5" />
            <circle id="bar-Oval-8" cx="3.5" cy="13.5" r="3.5" />
            <circle id="bar-Oval-8" cx="3.5" cy="23.5" r="3.5" />
          </g>
          <g id="bar-Group-46" transform="translate(110.000000, 0.000000)">
            <circle id="bar-Oval-8" cx="3.5" cy="3.5" r="3.5" />
            <circle id="bar-Oval-8" cx="3.5" cy="13.5" r="3.5" />
            <circle id="bar-Oval-8" cx="3.5" cy="23.5" r="3.5" />
          </g>
        </g>
        <g
          id="bar-Group-47"
          transform="translate(0.000000, 42.000000)"
          fill={styleguide.colors.illustrationMarl}>
          <g id="bar-Group-46">
            <circle id="bar-Oval-8" cx="3.5" cy="3.5" r="3.5" />
            <circle id="bar-Oval-8" cx="3.5" cy="13.5" r="3.5" />
            <circle id="bar-Oval-8" cx="3.5" cy="23.5" r="3.5" />
          </g>
          <g id="bar-Group-46" transform="translate(10.000000, 0.000000)">
            <circle id="bar-Oval-8" cx="3.5" cy="3.5" r="3.5" />
            <circle id="bar-Oval-8" cx="3.5" cy="13.5" r="3.5" />
            <circle id="bar-Oval-8" cx="3.5" cy="23.5" r="3.5" />
          </g>
          <g id="bar-Group-46" transform="translate(20.000000, 0.000000)">
            <circle id="bar-Oval-8" cx="3.5" cy="3.5" r="3.5" />
            <circle id="bar-Oval-8" cx="3.5" cy="13.5" r="3.5" />
            <circle id="bar-Oval-8" cx="3.5" cy="23.5" r="3.5" />
          </g>
          <g id="bar-Group-46" transform="translate(30.000000, 0.000000)">
            <circle id="bar-Oval-8" cx="3.5" cy="3.5" r="3.5" />
            <circle id="bar-Oval-8" cx="3.5" cy="13.5" r="3.5" />
            <circle id="bar-Oval-8" cx="3.5" cy="23.5" r="3.5" />
          </g>
          <g id="bar-Group-46" transform="translate(40.000000, 0.000000)">
            <circle id="bar-Oval-8" cx="3.5" cy="3.5" r="3.5" />
            <circle id="bar-Oval-8" cx="3.5" cy="13.5" r="3.5" />
            <circle id="bar-Oval-8" cx="3.5" cy="23.5" r="3.5" />
          </g>
          <g id="bar-Group-46" transform="translate(50.000000, 0.000000)">
            <circle id="bar-Oval-8" cx="3.5" cy="3.5" r="3.5" />
            <circle id="bar-Oval-8" cx="3.5" cy="13.5" r="3.5" />
            <circle id="bar-Oval-8" cx="3.5" cy="23.5" r="3.5" />
          </g>
          <g id="bar-Group-46" transform="translate(60.000000, 0.000000)">
            <circle id="bar-Oval-8" cx="3.5" cy="3.5" r="3.5" />
            <circle id="bar-Oval-8" cx="3.5" cy="13.5" r="3.5" />
            <circle id="bar-Oval-8" cx="3.5" cy="23.5" r="3.5" />
          </g>
          <g id="bar-Group-46" transform="translate(70.000000, 0.000000)">
            <circle id="bar-Oval-8" cx="3.5" cy="3.5" r="3.5" />
            <circle id="bar-Oval-8" cx="3.5" cy="13.5" r="3.5" />
            <circle id="bar-Oval-8" cx="3.5" cy="23.5" r="3.5" />
          </g>
          <g id="bar-Group-46" transform="translate(80.000000, 0.000000)">
            <circle id="bar-Oval-8" cx="3.5" cy="3.5" r="3.5" />
            <circle id="bar-Oval-8" cx="3.5" cy="13.5" r="3.5" />
            <circle id="bar-Oval-8" cx="3.5" cy="23.5" r="3.5" />
          </g>
          <g id="bar-Group-46" transform="translate(90.000000, 0.000000)">
            <circle id="bar-Oval-8" cx="3.5" cy="3.5" r="3.5" />
            <circle id="bar-Oval-8" cx="3.5" cy="13.5" r="3.5" />
            <circle id="bar-Oval-8" cx="3.5" cy="23.5" r="3.5" />
          </g>
          <g id="bar-Group-46" transform="translate(100.000000, 0.000000)">
            <circle id="bar-Oval-8" cx="3.5" cy="3.5" r="3.5" />
            <circle id="bar-Oval-8" cx="3.5" cy="13.5" r="3.5" />
            <circle id="bar-Oval-8" cx="3.5" cy="23.5" r="3.5" />
          </g>
          <g id="bar-Group-46" transform="translate(110.000000, 0.000000)">
            <circle id="bar-Oval-8" cx="3.5" cy="3.5" r="3.5" />
            <circle id="bar-Oval-8" cx="3.5" cy="13.5" r="3.5" />
            <circle id="bar-Oval-8" cx="3.5" cy="23.5" r="3.5" />
          </g>
        </g>
        <g
          id="bar-Group-24-Copy"
          transform="translate(63.460324, 45.213510) rotate(445.000000) translate(-63.460324, -45.213510) translate(22.960324, -5.286490)"
          stroke={styleguide.colors.illustrationStroke}
          stroke-width="1.25">
          <path
            d="M73.853194,68.9716716 C73.853194,43.3956129 53.3329235,22.6621207 28.019887,22.6621207 C12.897372,22.6621207 -0.514553643,30.0621257 -8.86238328,41.4737838"
            id="bar-Oval-6"
            transform="translate(32.495405, 45.816896) rotate(-76.000000) translate(-32.495405, -45.816896) "
          />
          <path
            d="M72.8684848,107.398746 C72.8684848,99.9719796 71.0975885,92.9483762 67.9449385,86.7072443"
            id="bar-Oval-6"
            transform="translate(70.406712, 97.052995) rotate(82.000000) translate(-70.406712, -97.052995) "
          />
          <path
            d="M27.4594814,97.2989093 C27.4594814,93.9187021 27.0056451,90.6223259 26.1435336,87.4458133"
            id="bar-Oval-6"
            transform="translate(26.801508, 92.372361) rotate(131.000000) translate(-26.801508, -92.372361) "
          />
        </g>
        <g
          id="bar-Group-24-Copy"
          transform="translate(104.440486, 87.005154) rotate(238.000000) translate(-104.440486, -87.005154) translate(82.440486, 54.505154)"
          stroke={styleguide.colors.illustrationStroke}
          stroke-width="1.25">
          <path
            d="M49.519462,46.2463421 C49.519462,29.0972846 35.7603719,15.1952267 18.787674,15.1952267 C8.64784428,15.1952267 -0.345014456,20.1570198 -5.94233544,27.8086749"
            id="bar-Oval-6"
            transform="translate(21.788563, 30.720784) rotate(-76.000000) translate(-21.788563, -30.720784) "
          />
          <path
            d="M18.314505,65.2844908 C18.314505,63.0180209 18.0102023,60.8077606 17.432146,58.6778705"
            id="bar-Oval-6"
            transform="translate(17.932146, 61.981181) rotate(131.000000) translate(-17.932146, -61.981181) "
          />
        </g>
      </g>
    </g>
  </svg>
)



// WEBPACK FOOTER //
// ./src/components/Sections/HowItWorks/Background/BarSvg.jsx